
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/eleccions-parlament-catalunya-2021/candidats",
      function () {
        return require("private-next-pages/3catinfo/eleccions-parlament-catalunya-2021/candidats/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/eleccions-parlament-catalunya-2021/candidats"])
      });
    }
  